import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: {
      display: 'flex',
    },
    count: {
      marginLeft: theme.spacing(0.5),
    },
  };
};
